import { getProductCover } from "../../helpers/product.media";
import ProductCardCarousel from "./product.card.carousel";
import { useDispatch, useSelector } from "react-redux";
import Col from "../element/col";
import Row from "../element/row";

import Container from "../element/container";
import Image from "../element/image";
import Icon from "../element/icon";
import formatNumber from "../../helpers/format.number";
import { useLocation, useNavigate } from "react-router-dom";
import { DcLogo } from "../../assets/images";

import { Skeleton } from "primereact/skeleton";
import useWindowDimension from "../hook/use.window.dimension";
import { saveProduct } from "../../redux/reducer/product.reducer";
import { openLoginModal } from "../../redux/reducer/modal.reducer";
import { handleCatchError } from "../../helpers/handle.catch.error";

import { setSavedProduct } from "../../redux/reducer/product.reducer";
import { useTranslation } from "react-i18next";

export default function CommonProduct({
  className,
  product,
  key,
  loading = false,
  type,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { width } = useWindowDimension();
  const location = useLocation();

  const { savedProduct } = useSelector((state) => state.product);
  const { token, username } = useSelector((state) => state.common);
  const isCarPlate = product?.category === "car plate";
  const productStatus = String(
    product?.status?.name ??
      product?.status?.value ??
      product?.status ??
      product?.availability_status ??
      product?.product_status ??
      "",
  ).toLowerCase();
  const isReserved = productStatus === "reserved";

  const handleSaveProduct = (id) => {
    if (token && username) {
      const isSaved = savedProduct?.includes(product?.id);

      dispatch(
        setSavedProduct(
          isSaved
            ? savedProduct.filter((savedId) => savedId !== id)
            : [...savedProduct, id],
        ),
      );

      dispatch(
        saveProduct({
          product_id: id,
          action: isSaved ? "remove" : "add",
        }),
      )
        .unwrap()
        .then((res) => {})
        .catch((ex) => {
          dispatch(
            setSavedProduct(
              isSaved
                ? [...savedProduct, id]
                : savedProduct.filter((savedId) => savedId !== id),
            ),
          );
          handleCatchError(ex);
        });
    } else {
      dispatch(openLoginModal());
    }
  };

  const handleOpenProduct = (id) => {
    if (!id) return;

    // dispatch(
    //   getProductInfo({
    //     id: id,
    //   }),
    // );

    const productPath = `/${isCarPlate ? "car-plate" : "car"}/${id}`;

    if (width >= 992) {
      navigate(productPath);
    } else {
      navigate(productPath, {
        state: { backgroundLocation: location },
      });
    }
  };



  return (
    <Col
      className={`common-product ${className ?? ""} ${
        isCarPlate ? "car-plate" : ""
      } ${isReserved ? "reserver" : ""} ${type ?? ""} pointer`}
    >
      <Col
        className="product-box"
        key={key}
        onClick={() => handleOpenProduct(product?.id)}
      >
        {loading ? (
          <Col className="product-bg product-card-skeleton">
            <Skeleton className="product-image-skeleton" />
            <Col className="_col product-info product-info-skeleton">
              <Row className="_row skeleton-tag-row">
                <Skeleton width="34%" height="1.8rem" />
                <Skeleton width="22%" height="1.3rem" />
              </Row>
              <Skeleton width="78%" height="1.8rem" />
              <Skeleton width="100%" height="1px" />
              <Row className="_row skeleton-price-row">
                <Col className="_col skeleton-price-copy">
                  <Skeleton width="42%" height="1.1rem" />
                  <Skeleton width="68%" height="2.1rem" />
                </Col>
                <Skeleton width="28%" height="3rem" borderRadius="999px" />
              </Row>
              <Skeleton width="100%" height="1.2rem" />
              <Skeleton width="100%" height="1.2rem" />
            </Col>
          </Col>
        ) : (
          // <Skeleton className="product-bg" />
          <Col className="product-bg relative">
            <Row className="product-header">
              {product?.tag?.length > 0 ? (
                <Row className="items-center dcar-badge">
                  {type !== "deal" &&
                    product?.tag[0]?.toLowerCase() === "dcar certified" && (
                      <Icon
                        tag="span"
                        icon="streamline-ultimate:car-3-bold"
                        className="_svg badge"
                        gradient
                        width={12}
                        height={12}
                      />
                    )}
                  <p
                    className={`_label badge-title ${type === "deal" ? "exclusive-deals" : ""} `}
                  >
                    {t(
                      type === "deal"
                        ? "Exclusive Deals"
                        : product?.tag[0] === "DCar certified"
                          ? "DCAR Certified"
                          : product.tag[0],
                    )}
                  </p>
                </Row>
              ) : (
                <Row></Row>
              )}
              {isCarPlate ? (
                <h3 className="_label car-plate">{product?.name}</h3>
              ) : (
                ""
              )}
              {(type === "list" || type === "recommend") && (
                <Icon
                  icon="icon-park:like"
                  className={`_svg ${
                    // product?.is_saved == true ||
                    savedProduct?.includes(product?.id) ? "like" : "unlike"
                  }`}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSaveProduct(product?.id);
                  }}
                />
              )}
            </Row>
            {!isCarPlate && (
              <>
                {type === "list" ? (
                  <ProductCardCarousel
                    media={product?.media}
                    name={product?.name}
                  />
                ) : (
                  <Image
                    className={`_img ${getProductCover(product?.media) ? "" : "default"}`}
                    src={getProductCover(product?.media)?.url || DcLogo}
                  />
                )}
                {isReserved && (
                  <Container tag="div" className="reserver-overlay">
                    <p className="_label reserver-title">{t("RESERVED")}</p>
                  </Container>
                )}
              </>
            )}
            {isCarPlate ? (
              <Row className="_col product-info">
                <p className="_label product-price">
                  RM {formatNumber(product?.price)}
                </p>
              </Row>
            ) : type === "deal" ? (
              <></>
            ) : (
              <Col className="_col product-info">
                <Row className="_row listing-meta">
                  <Col className="_col flex flex-col gap-4 w-100">
                    {/* {Array.isArray(product?.properties?.small_tag) &&
                      product.properties.small_tag?.length > 0 && ( */}
                    {(product?.year || product?.mileage) && (
                      <Row className="flex justify-between row-gap-2">
                        <Row className="_row tag-list gap-2">
                          {product.year && (
                            <p className="_label tag-title">
                              {t("Register at")} {product?.year}
                            </p>
                          )}
                          {product?.mileage && (
                            <p className="_label tag-title">
                              {formatNumber(product.mileage)} km
                            </p>
                          )}
                        </Row>
                        {product?.view_location && (
                          <Row className="items-center gap-2">
                            <Icon
                              icon="f7:location-fill"
                              className="_svg location"
                            />
                            <p className="_label product-location">
                              {product.view_location}
                            </p>
                          </Row>
                        )}
                      </Row>
                    )}
                    {/* )} */}
                    <Row className="flex item-center justify-between">
                      <h6 className="_label product-title">{product?.name}</h6>
                      {product?.view_location &&
                        !product?.year &&
                        !product?.mileage && (
                          <Row className="items-center gap-2">
                            <Icon
                              icon="f7:location-fill"
                              className="_svg location"
                            />
                            <p className="_label product-location">
                              {product.view_location}
                            </p>
                          </Row>
                        )}
                    </Row>
                  </Col>
                </Row>
                <Container tag="div" className="product-divider"></Container>
                <Col className="_row listing-bottom">
                  <Row className="_row listing-price">
                    <Col>
                      <p className="_label asking-price">{t("Final Price")}</p>
                      <h4 className="_label product-price">
                        RM {formatNumber(product?.price)}
                      </h4>
                    </Col>
                    <button type="button" className="_button detail-button">
                      {t("More Details")}
                    </button>
                  </Row>
                  {(product?.service_prices?.conditioning ||
                    product?.service_prices?.warranty) && (
                    <Col className="_col pricing-side mt-3">
                      {parseFloat(product?.service_prices?.conditioning) >
                        0 && (
                        <Row className="w-100 flex items-center justify-between">
                          <p className="_label detail-line">
                            {t("Conditioning Cost")}
                          </p>
                          <p className="_label side-value">
                            +RM{" "}
                            {formatNumber(
                              product?.service_prices?.conditioning,
                            )}
                          </p>
                        </Row>
                      )}
                      {parseFloat(product?.service_prices?.warranty) > 0 && (
                        <Row className="w-100 flex items-center justify-between">
                          <p className="_label detail-line">
                            {t("Warranty Cost")}
                          </p>
                          <p className="_label side-value">
                            +RM{" "}
                            {formatNumber(product?.service_prices?.warranty)}
                          </p>
                        </Row>
                      )}
                    </Col>
                  )}
                </Col>
              </Col>
            )}
          </Col>
        )}
      </Col>
      {type === "deal" && (
        <Col
          className="_col product-info"
          onClick={() => handleOpenProduct(product?.id)}
        >
          <h6 className="_label product-title deal">{product?.name}</h6>
          <Row className="items-center gap-50">
            <Icon icon="ic:round-local-offer" className="_svg deal" />
            <p className="_label product-price">
              RM {formatNumber(product?.price)} {t("OFF")}
            </p>
          </Row>
        </Col>
      )}
    </Col>
  );
}
